import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as NewRoute from "./new";
import * as ListRoute from "./list";
import * as SectionRoute from "./section";
import SectionPublicSchema from "@common/schema/section/public";
import * as Section from "@repoflow/components/section";

// `Section` here is the routing/form primitive every screen in this app is
// wrapped in — not the entity. They share a word and nothing else; the entity
// is only ever reached through QueriesQL and SectionPublicSchema, so there is
// nothing to alias.
const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  // Off the SITE's base rather than the app root: every screen below lives at
  // /site/:siteId/section/..., and `params` carries the siteId every query
  // beneath here takes as a variable.
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/section`;
  const basepath = `${parentBasepath}/section`;

  return (
    <Section.Provider
      schema={SectionPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:sectionId`} component={SectionRoute.Content} />
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <>
            <BreadcrumbItem>
              <Link to={base}>Sections</Link>
            </BreadcrumbItem>
            <Switch>
              <Route path={`${basepath}/new`} component={NewRoute.Indice} />
              <Route
                path={`${basepath}/:sectionId`}
                component={SectionRoute.Indice}
              />
              <Route path={`${basepath}/`} component={ListRoute.Indice} />
            </Switch>
          </>
        </>
      )}
    </LocalProvider>
  );
}
export const Sidebar = () => <></>;
